import { TimeOptions } from './time-options.model';

export enum LuDatetimePickerPlacement {
	TOP = 'top',
	BOTTOM = 'bottom',
	LEFT = 'left',
	RIGHT = 'right',
	AUTO = 'auto'
}

export enum DateTimeTypes {
	PRIMARY = 1,
	SECONDARY = 2
}

export enum TimeFormatType {
	AM = 'AM',
	PM = 'PM'
}

export enum RemapDateFormats {
	DAY_MONTH_YEAR = 'dd/MM/yyyy',
	DAY_MONTH_YEAR_DASHED = 'dd-MM-yyyy'
}

export interface LuDatetimePickerConfig {
	primaryId: string;
	primaryTimePickerId: string;
	secondaryId: string;
	secondaryTimePickerId: string;
	timeOptions: TimeOptions;
	placeholderFrom: string;
	placeholderTo: string;
	disabled?: boolean;
	dateRange: boolean;
	minValue?: Date;
	maxValue?: Date;
	readonly?: boolean;
	primaryRequired: boolean;
	primaryRequiredMessage: string;
	secondaryRequired: boolean;
	secondaryRequiredMessage: string;
	labelDatePicker: string;
	labelTimePicker: string;
	labelDateRangeTo: string;
	labelTimePickerTo: string;
	inlineDatePicker: boolean;
	datepickerColsClass: string;
	timepickerColsClass: string;
	hideTimepicker?: boolean;
	hideDatepicker?: boolean;
	localeDateTime: boolean;
	dateOnly?: boolean;
	dateFormat?: string;
	placement?: LuDatetimePickerPlacement;
	required?: boolean;
	displayClearButton?: boolean;
}
